import { render, staticRenderFns } from "./OrdersPartnerBilling.vue?vue&type=template&id=5527f55a&"
import script from "./OrdersPartnerBilling.vue?vue&type=script&lang=js&"
export * from "./OrdersPartnerBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports